import { render, staticRenderFns } from "./BenefitsLayout.vue?vue&type=template&id=2be13751&"
import script from "./BenefitsLayout.vue?vue&type=script&lang=js&"
export * from "./BenefitsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports